module.exports = __webpack_public_path__ + "img/logo-arenabet-mob.9627f2b1.svg";